export default {
    code: 'BES_NZ_ROYAL_NEW_ZEALAND_YACHT_SQUADRON__RNZYS_',
    baskets: {
        includePublicBaskets: false,
        businessCodes: ['RNZYS_BASKET'],
        individualCodes: ['RNZYS_BASKET'],
    },
}
